module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.courseConfigsPending) ? _c('v-card-title', [_c('v-alert', {
    attrs: {
      "color": "error",
      "value": true
    }
  }, [_vm._v("\n        Prezado(a) Coordenador(a), o cronograma público está desabilitado para o seu curso. "), _c('br'), _vm._v("\n        Acesse "), _c('router-link', {
    staticClass: "white--text",
    attrs: {
      "to": "/curso/configuracoes"
    }
  }, [_c('strong', [_c('v-icon', [_vm._v("settings")]), _vm._v(" Definições do curso")], 1)]), _vm._v(" e defina a data de publicação e início das inscrições.\n    ")], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-093c11e3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserWarnings.vue
// module id = 236
// module chunks = 0